import { useTranslation as useI18nextTranslation } from "react-i18next";

export const useTranslation = (ns: string = "swap") => {
  const { t, i18n } = useI18nextTranslation(ns);

  return {
    t,
    i18n,
    language: i18n.language,
    changeLanguage: i18n.changeLanguage.bind(i18n),
  };
};
